<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<form #form="ngForm" [formGroup]="voucherService.searchForm" class="form-field-full">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <mat-icon>search</mat-icon> Search Vouchers & Applications
      </h2>
    </div>
  </div>
  <div fxLayout="row wrap" class="matero-row">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>OHA Voucher Id</mat-label>
              <input id="wellId" name="voucherId" formControlName="voucherId" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>OHA Application Id</mat-label>
              <input id="applicationId" name="applicationId" formControlName="applicationId" matInput />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Voucher Identifier (VT-)</mat-label>
              <input id="applicationIdentifier" name="applicationIdentifier" formControlName="applicationIdentifier" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Voucher Type</mat-label>
              <mat-select id="type" name="type" formControlName="type">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let item of voucherService.types" value="{{item}}">{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard" style="width:100%;">
              <mat-label>Address</mat-label>
              <input id="address" name="address" formControlName="address" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>City</mat-label>
              <input id="city" name="city" formControlName="city" matInput />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Zip</mat-label>
              <input id="zip" name="zip" formControlName="zip" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>County</mat-label>
              <mat-select id="county" name="county" formControlName="county">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Status</mat-label>
              <mat-select id="status" name="status" formControlName="status">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let item of voucherService.statuses" value="{{item}}">{{item}}</mat-option>
                <mat-option value="{{voucherService.notEligible}}">{{voucherService.notEligible}}</mat-option>
              </mat-select>
            </mat-form-field>

          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Contact</mat-label>
              <input id="contact" name="contact" formControlName="contact" matInput />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Well Log</mat-label>
              <input id="wellLog" name="wellLog" formControlName="wellLog" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Well Tag</mat-label>
              <input id="wellTag" name="wellTag" formControlName="wellTag" matInput />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Received Start Date</mat-label>
              <input id="receivedStartDate" name="receivedStartDate" formControlName="receivedStartDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerReceivedStart" />
              <mat-datepicker-toggle matSuffix [for]="datepickerReceivedStart"></mat-datepicker-toggle>
              <mat-datepicker #datepickerReceivedStart>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Received End Date</mat-label>
              <input id="receivedEndDate" name="receivedEndDate" formControlName="receivedEndDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerReceivedEnd" />
              <mat-datepicker-toggle matSuffix [for]="datepickerReceivedEnd"></mat-datepicker-toggle>
              <mat-datepicker #datepickerReceivedEnd>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <br />
            <mat-checkbox formControlName="exceedencesDetected"> Has Exceedances</mat-checkbox>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <br />
            <mat-checkbox formControlName="redeemed"> Redeemed</mat-checkbox>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="100" fxFlex.lt-sm="100"><br /><br /></div>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row wrap" class="matero-row">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonSearch" (click)="onSubmit()" mat-raised-button color="primary" title="Search" [disabled]='processing'>Search</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic" title="Clear" [disabled]='processing'>Clear</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonDownload" (click)="download()" mat-raised-button color="accent" title="Export Search Results"
          [disabled]='!showResults || processing || authService.isReadOnly()'>Export Search Results</button>
        &nbsp;&nbsp;
        <button type="submit" id="mergeVouchersButton" (click)="openMergeVouchersDialog()" mat-raised-button color="warn" title="Merge Vouchers"
          [disabled]='!showResults || processing || searchResultsCount <= 0 || checkboxActionList.length <= 1 || authService.isReadOnly()'>
          <mat-icon class="icon-20">merge_type</mat-icon> Merge Vouchers
        </button>
      </mat-card>
    </div>
  </div>
</form>

<mat-card [hidden]="!showResults">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Results ({{searchResultsCount}}) </strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>Results ({{searchResultsCount}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="selectRow">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="4" fxFlex.lt-sm="100">&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="4">
          <input type="checkbox" (click)="clickCheckboxAction(result.voucherId)"
            [hidden]="result.applicationIdentifier == undefined || result.applicationIdentifier == null || result.applicationIdentifier.length == 0" />
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10" fxFlex.lt-sm="100">Voucher Identifier</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="10" fxFlex.lt-sm="100">
          <a title="Edit Voucher {{result.applicationIdentifier}}" (click)="editVoucher(result.voucherId)">{{result.applicationIdentifier}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationId">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="6" fxFlex.lt-sm="100">OHA Application Id</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="6" fxFlex.lt-sm="100">
          <span *ngIf="result.applicationIdentifier != null && result.applicationIdentifier.length > 0">{{result.voucherApplicationId}}</span>
          <a *ngIf="result.applicationIdentifier == null || result.applicationIdentifier.length == 0" [routerLink]="['/vouchers/application/edit/', result.voucherApplicationId]"
            title="Edit Voucher Application {{result.voucherApplicationId}}">{{result.voucherApplicationId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationStatus">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="6" fxFlex.lt-sm="10">Status</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="6">
          {{result.applicationStatus}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationType">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="8" fxFlex.lt-sm="100">Type</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="8" fxFlex.lt-sm="100">
          {{result.applicationType}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="wellId">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="14" fxFlex.lt-sm="100">OHA Well Id</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="14" fxFlex.lt-sm="100">
          {{result.wellId}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="14" fxFlex.lt-sm="100">Address</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="14" fxFlex.lt-sm="100">
          {{result.wellAddress1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCity}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellState">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="4" fxFlex.lt-sm="100">State</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="4" fxFlex.lt-sm="100">
          {{result.wellState}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellZip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellZip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCounty">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCounty}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellLog">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Log</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellLog}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellLabelTagNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellTag}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="score">
        <mat-header-cell *matHeaderCellDef mat-sort-header>% Match</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.score}}
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>